import './assets/fonts/fonts.css';

export const light = 'Proxima Nova Light, Helvetica, Arial, sans-serif';
export const regular = 'Proxima Nova Regular, Helvetica, Arial, sans-serif';
